import {
  Accordion,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography,
  styled,
} from '@mui/material';

import { textFieldDefaultStyle } from '../../../../../../components/UI/Typography';

export const CriteriasContainerGrid = styled(Grid)(() => ({
  marginTop: '40px',
  border: '1px solid #D7D8DB',
  borderRadius: '8px',
  padding: '40px',
}));

export const NoContentText = styled(Typography)(() => ({
  fontSize: '14px',
  color: '#8B8C8E',
  opacity: 0.8,
}));

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  width: '100%',
  backgroundColor: 'transparent',
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: '70px',
  height: '70px',
  margin: '0',

  // Remove todas as transições do summary
  transition: 'none !important',

  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
    transition: 'none',
  },

  // Remove margens quando expandido
  '&.Mui-expanded': {
    minHeight: '70px',
    margin: '0 !important',

    '& .MuiAccordionSummary-content': {
      margin: '0 !important',
    },
  },

  // Estilo para o ícone de expandir
  '& .expandIcon': {
    color: theme.palette.primary.main,
    marginLeft: '12px',
    transition: 'transform 0.3s ease',
    display: 'inline-flex',
    '& span': {
      fontWeight: 700,
    },

    '.Mui-expanded &': {
      transform: 'rotate(180deg)',
    },
  },
}));

export const AccordionTitle = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
}));

export const ContentContainer = styled(Box)(() => ({
  paddingLeft: '12px',
  paddingTop: '6px',
}));

export const ScrollableGrid = styled(Grid)(() => ({
  width: '96%',
  maxHeight: '400px',
  overflowY: 'scroll',
  borderRadius: '6px',
  '& > .MuiGrid-item': {
    width: '100%',
    display: 'block',
  },

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#8B8C8E',
    borderRadius: '4px',
  },
}));

export const AccordionCriteria = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontWeight: '600',
  margin: '12px 0',
  cursor: 'pointer',
  '& span': { color: theme.palette.secondary.main },
}));

export const InfoBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  borderLeft: '1px solid #D7D8DB',
  paddingLeft: 8,
  maxWidth: 600,
}));

export const DisplacementText = styled(Box)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.common.grey,
  fontWeight: 500,
  display: 'flex',
  gap: 2,
}));

export const DisplacementValue = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 600,
  marginLeft: '4px',
}));

export const ItemTitle = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 700,
  marginTop: '12px',
}));

export const TypologyGroupName = styled(Typography)(() => ({
  fontSize: '18px',
}));

export const StyledDottedDivider = styled(Divider)(() => ({
  borderStyle: 'dotted',
  borderBottomWidth: '1px',
  borderBottomColor: '#D7D8DB',
  marginBottom: '24px',
}));

export const SubsectionTitle = styled(Typography)(() => ({
  fontWeight: 500,
  marginBottom: 24,
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  width: '210px',
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: theme.palette.secondary.main,
  fontFamily: 'Montserrat',
  fontWeight: '600',
  height: '48px',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  width: '210px',
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  fontWeight: '600',
  height: '48px',
  color: '#FAFCFF',
  backgroundColor: theme.palette.secondary.main,
  fontFamily: 'Montserrat',
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
}));

export const TitleMoldal = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '18px',
  display: 'flex',
  gap: 4,
  span: {
    color: theme.palette.primary.main,
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  width: '100%',
  textAlign: 'start',
  '&.MuiOutlinedInput-root': {
    borderRadius: 16,
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.grey,
    },
  },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.common.grey,
  '&.Mui-focused': {
    color: theme.palette.common.grey,
  },
}));

export const EditTypologyGroupBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: '12px',
  gap: 4,
  span: {
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));
